// extracted by mini-css-extract-plugin
export default {"App":"app_App__vBANr","container":"app_container__8km0M"};